import { render, staticRenderFns } from "./ReorderPage.vue?vue&type=template&id=109ca79e&"
import script from "./ReorderPage.vue?vue&type=script&lang=js&"
export * from "./ReorderPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports